import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import Image from "next/image"
import { colors, mediaQueries, sizes } from "ui"
import { getNonUmbracoUrl } from "utils"
import ButtonWithArrow, {
  ArrowNoLineIndex,
  colorPalletteIndexType,
} from "../common/bit/ButtonWithArrow"

interface StripWithIconAndArrowProps {
  logo: string
  link?: {
    url?: string
    name?: string
    text?: string
    href?: string
    target?: string
  }
  ArrowIcon?: any
  bgcolor?: string
  logoWidth?: number
  logoHeight?: number
}

const StyledStripLeadProductContainer = styled(ButtonWithArrow)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  border-radius: ${sizes.baseDouble};
  background: ${colors.white};
  backdrop-filter: blur(10px);
  padding: 8px 8px 8px 12px;
  width: 100%;
  height: 100%;
  ${mediaQueries.mobile} {
  }
  ${mediaQueries.desktopM} {
    flex-direction: row;
    justify-content: flex-start;
    width: 250px;
    height: unset;
    gap: 10px;
  }
  ${mediaQueries.desktopXl} {
    width: 280px;
  }
`
const StyledStripLeadProductTitle = styled(Typography)<{ component: string }>`
  text-align: center;
  width: 100%;
  margin-inline-end: auto;
  ${mediaQueries.desktopM} {
    text-align: start;
  }
`
const StyledImageContainer = styled(Box)<{ bgcolor?: string }>`
  background-color: ${({ bgcolor }) => bgcolor};
  border-radius: ${sizes.baseSingle};
  display: flex;
  align-items: center;
`
const StripWithIconAndArrow = ({
  logo,
  link,
  bgcolor,
  logoWidth = 48,
  logoHeight = 48,
}: StripWithIconAndArrowProps) => {
  const colorName = colors.resolveColorName("#" + bgcolor) as
    | colorPalletteIndexType
    | undefined
  const href = link?.url || link?.href

  return (
    <StyledStripLeadProductContainer
      href={href ? getNonUmbracoUrl(href) : undefined}
      target={link?.target}
      variant="elevated"
      arrowName={
        ArrowNoLineIndex.elevated[colorName as colorPalletteIndexType] ||
        "arrow_lightPink_black"
      }
      colorPallette={colorName || "red"}
    >
      <StyledImageContainer bgcolor={"#" + bgcolor}>
        {logo && (
          <Image
            src={logo}
            alt={link?.name || link?.text || "logo"}
            width={logoWidth}
            height={logoHeight}
          />
        )}
      </StyledImageContainer>
      <StyledStripLeadProductTitle variant="h5" component="p">
        {link?.name ?? link?.text}
      </StyledStripLeadProductTitle>
    </StyledStripLeadProductContainer>
  )
}

export default StripWithIconAndArrow
